module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-b0dd4f96.png";